import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, Input, Spinner } from "reactstrap";
import { API_BASE_URL } from "../../api/api";
import { useDataFetch } from "../../Hooks/Use-data-fetch";

export const PaymentProofModal = ({ isOpen, toggle, order }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [proofUrl, setProofUrl] = useState(
    order?.payment_proof ? `${API_BASE_URL}/order/payment-proof/${order.payment_proof}` : null
  );
  
  const { postData } = useDataFetch();

  const { mutateAsync: uploadProof } = postData(
    "/order/upload/payment-proof",
    {},
    {
      onSuccess: (response) => {
        if (response && response.fileName) {
          setProofUrl(`${API_BASE_URL}/order/payment-proof/${response.fileName}`);
        }
        setIsUploading(false);
      },
      onError: (err) => {
        console.error("Error subiendo comprobante:", err);
        setIsUploading(false);
      },
    }
  );

  const handleFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setIsUploading(true);

    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64String = reader.result;
      try {
        const payload = {
          orderId: order.id,
          file: {
            name: file.name,
            base64URL: base64String,
          },
        };

        await uploadProof(payload);
      } catch (err) {
        console.error("Upload failed:", err);
        setIsUploading(false);
      }
    };

    reader.readAsDataURL(file);
  };


  if (!order) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="sm" centered>
      <ModalHeader toggle={toggle}>Comprobante de pago</ModalHeader>
      <ModalBody className="text-center">
        {proofUrl ? (
          <img
            src={proofUrl}
            alt="Comprobante de pago"
            style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
          />
        ) : (
          <>
            <div>No se encontró comprobante para esta orden.</div>
            <div className="mt-3">
              <Input
                type="file"
                accept="image/*"
                onChange={handleFileUpload}
                disabled={isUploading}
              />
              {isUploading && (
                <div className="mt-2">
                  <Spinner size="sm" color="primary" /> Subiendo comprobante...
                </div>
              )}
            </div>
          </>
        )}
      </ModalBody>
    </Modal>
  );
};
